import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import moment from 'moment';
import { APPOINTMENT_STATUS } from '_constants';
import { buildAppointmentStatus } from 'actions';

const MonthAppointmentRow = ({ ...props }) => {
  function getContactName (contacts) {
    if (contacts && contacts.length > 0) { return contacts[0].firstName + ' ' + contacts[0].lastName; }
  }

  function redirect (id, toReferral = false, contactId) {
    if (toReferral) {
      props.history.push(`/referraldetails/${contactId}/appointment/${id}`);
    } else {
      props.history.push(`/appointmentdetails/${id}/`, { headerTitle: 'Appointment Details' });
    }
  }

  const isAppointmentDone = (appointmentStatusId) => {
    if (!appointmentStatusId) { return false; }
    return appointmentStatusId === APPOINTMENT_STATUS.COMPLETED.id ||
    appointmentStatusId === APPOINTMENT_STATUS.CANCELLED.id;
  };

  const { appointment = {} } = props;
  const appointmentStatusId = get(props, 'appointment.eventStatus.id', '');
  const appointmentId = props.appointment.id || props.appointment.calendarEventKey;
  const contactId = get(props, 'appointment.contactIDs[0].id', '');

  return (
    <div className='appointment-row' onClick={() => redirect(appointmentId, isAppointmentDone(appointmentStatusId), contactId)}>
      <div className='time'>
        {moment(props.appointment.startDate).format('hh:mm A')}
      </div>
      <div className='appointment-details'>
        <h3>{appointment.name}</h3>
        <p>{getContactName(appointment.contacts)}</p>
      </div>
      {buildAppointmentStatus(props.appointment)}
    </div>
  );
};

MonthAppointmentRow.propTypes = {
  appointment: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default connect((state) => { return {}; })(withRouter(MonthAppointmentRow));
